import { Ref, defineComponent, onMounted, onUnmounted, ref } from 'vue'

export default defineComponent({
    name: 'HydratedRealEstateIframe',
    props: { iFrameUrl: { type: String, required: true } },
    setup() {
        const iFrameEl: Ref<null | HTMLIFrameElement> = ref(null)
        const handleMessageEvent = (event: MessageEvent) => {
            if (event.source === iFrameEl.value?.contentWindow) {
                iFrameEl.value.style.height = `${event.data.height}px`
            }
        }

        onMounted(() => window.addEventListener('message', handleMessageEvent))
        onUnmounted(() => window.removeEventListener('message', handleMessageEvent))

        return { iFrameEl }
    },
})
